<template>
  <b-row v-if="items.length > 0">
    <b-col>
      <h4 v-if="!withoutTitle">
        <b-badge variant="info">Présence vidéo</b-badge> (avec une application externe ou ajouté
        manuellement par l'organisateur)
      </h4>
      <b-table
        bordered
        class="agv-table"
        :items="items"
        :fields="fields"
        :is-busy="items == []"
        :tbody-tr-class="detailsClassFn"
      >
        <template #head(building_owner.lastname)>
          Nom
        </template>
        <template #head(representative)>
          Représenté par
        </template>
        <template #head(logs)>
          Logs
        </template>
        <template v-slot:cell(building_owner.lastname)="row">
          <div>
            <appMandateName
              :mandate="row.item"
              :presence-mandates="presenceMandates"
              :is-dummy-video-case="true"
            />
          </div>
        </template>
        <template v-slot:cell(representative)="row">
          <div>
            <appMandateRepresentant
              :main-mandate="row.item"
              :presence-mandates="presenceMandates"
              :is-dummy-video-case="true"
            />
          </div>
        </template>
        <template v-slot:cell(logs)="row">
          <div>
            <appMandatePresenceLogs
              :main-mandate="row.item"
              :presence-mandates="presenceMandates"
              :is-dummy-video-case="true"
            />
          </div>
        </template>
      </b-table>
    </b-col>
  </b-row>
</template>

<script>
import meetingPresenceMixin from "@/mixins/meeting-presence";

export default {
  components: {
    appMandateName: () => import("@/components/b-table-components/MandateName"),
    appMandateRepresentant: () => import("@/components/b-table-components/MandateRepresentant"),
    appMandatePresenceLogs: () => import("@/components/b-table-components/MandatePresenceLogs"),
  },
  mixins: [meetingPresenceMixin],
  props: {
    presenceMandates: {
      type: Array,
      default: () => {
        return [];
      },
    },
    withoutTitle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fields: [
        {
          key: "building_owner.lastname",
          sortable: true,
        },
        {
          key: "representative",
        },
        {
          key: "logs",
        },
      ],
    };
  },
  computed: {
    items() {
      var MandatesRepresentedByThemSelves = this.getPresentMandates(
        this.presenceMandates,
        "dummy_video"
      );
      var MandatesRepresentedByContacts = this.getMandatesRepresentedByContacts(
        this.presenceMandates,
        "dummy_video"
      );
      return [].concat(MandatesRepresentedByThemSelves, MandatesRepresentedByContacts);
    },
  },
  methods: {
    detailsClassFn(item, rowType) {
      // ...
      return "bg-info-light";
    },
  },
};
</script>
